import React, { useEffect, useState } from "react";

import "./admin.css";
import { toast } from "react-toastify";
import { getDatabase, ref, onValue } from "firebase/database";

export default () => {
  let [coustomer, setcoustomer] = useState([]);
  useEffect(() => {
    toast.loading("Loading Data");

    const db = getDatabase();
    const starCountRef = ref(db, "/Client");
    onValue(starCountRef, (snapshot) => {
      let arr = [];
      snapshot.forEach((element) => {
        arr.push(element.val());

        setTimeout(() => {
          setcoustomer(arr);
          toast.dismiss();
        }, 600);
      });
    });
  }, []);
  return (
    <>
      <table className="admin-data">
        <thead className="ishtyle">
          <tr>
            <th>First Name</th>
            <th>Last Name</th>
            <th>E-mail</th>
          </tr>
        </thead>
        <tbody>
          {coustomer.map((v, index) => {
            return (
              <tr key={index}>
                <td>{v.first_name}</td>
                <td>{v.last_name}</td>
                <td style={{ color: "#fff", fontSize: 19 }}>{v.email}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </>
  );
};
